<div class="smartCareSection">
  <div class="container">
    <div class="d-flex">
      <h2>Book an MOT, service or repair at an AA approved garage near you</h2>
      <img src="./assets/images/aa-autocenter-logo.svg" alt="AA Autocenter" />
    </div>
    <div class="sc_form">
      <form [formGroup]="smartCareModel" autocomplete="off">
        <div class="formItem">
          <label for="vrn">Registration number (number plate)</label>
          <input formControlName="vrn" maxlength="10" required id="vrn"
            [ngClass]="{ 'is-invalid': submitted && getErrors.vrnErrors }">
            @if (submitted && getErrors.vrnErrors) {
              <div class="invalid-feedback">
                @if (getErrors.vrnErrors.required) {
                    <span class="field-validation-error">
                    Enter your vehicle's number plate.</span>
                }
                @if (getErrors.vrnErrors.minlength) {
                    <span class="field-validation-error">
                    Check your number plate.</span>
                }
              </div>
            }
          </div>

          <div class="formItem">
            <label for="postcode">Postcode</label>
            <input formControlName="postCode" maxlength="8" required id="postCode"
              [ngClass]="{ 'is-invalid': submitted && getErrors.postCodeErrors }">
              @if (submitted && getErrors.postCodeErrors) {
                <div class="invalid-feedback">
                  @if (getErrors.postCodeErrors.required) {
                      <span class="field-validation-error">
                      Enter your postcode.</span>
                  }
                  @if (getErrors.postCodeErrors.minlength) {
                      <span class="field-validation-error">
                      Check your postcode.</span>
                  }
                </div>
              }
            </div>
            <button class="btn primary" (click)="redirectToSmartCare()">Get started</button>
          </form>
        </div>
      </div>
    </div>